<template>
  <div class="flex flex-col items-center text-center lg:items-start lg:text-left">
    <a href="/" class="mb-1 inline-block">
      <SvgLogoLillojeux class="h-20" />
    </a>
    <div class="text-base font-extrabold text-black">
      Boutique
    </div>
    <div class="text-sm font-medium tracking-tighter text-primary sm:text-base">
      Jeux de société – Casse-têtes – Salles d’évasion
    </div>
  </div>
</template>
